import ResumeBox from "@/common/components/ResumeBox";
import {getFullDateDiffFormatted} from "@/common/utils/date";
import {formatCurrency} from "@/common/utils/formatters";
import {BankingDepositsData} from "@/features/privateCompanies/types/bankingDeposits/bankingDeposits.type";
import {isAfter} from "date-fns";

interface BankingDepositResumeProps {
  bankingDeposit?: BankingDepositsData;
  isLoading?: boolean;
}

const BankingDepositResume = ({bankingDeposit, isLoading}: BankingDepositResumeProps) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex gap-3">
        <ResumeBox
          padding="small"
          boxClassName="flex-1"
          label="Forma de pagamento"
          value={bankingDeposit?.payment?.payment_method?.display_name || '--'}
          isLoading={isLoading}
          testId="banking_deposit_payment_method"
        />

        {(!bankingDeposit || (bankingDeposit?.status === "pending" && bankingDeposit?.payment?.source?.expires_at)) && (
          <ResumeBox
            padding="small"
            boxClassName="flex-1"
            label="Vencimento"
            value={bankingDeposit?.payment?.source?.expires_at
              ? isAfter(new Date(bankingDeposit.payment.source.expires_at), new Date())
                ? getFullDateDiffFormatted(new Date(bankingDeposit.payment.source.expires_at), new Date())
                : 'Vencido'
              : '--'}
            isLoading={isLoading}
            testId="banking_deposit_expires_at"
          />
        )}
      </div>

      <div className="flex gap-3">
        <ResumeBox
          padding="small"
          boxClassName="flex-1"
          label="Valor requisitado"
          value={(bankingDeposit?.created_at && formatCurrency(Number(bankingDeposit.requested_total))) || '--'}
          isLoading={isLoading}
          testId="banking_deposit_requested_total"
        />

        <ResumeBox
          padding="small"
          boxClassName="flex-1 text-valid"
          label="Tarifa"
          value={(bankingDeposit?.created_at && formatCurrency(Number(bankingDeposit.fee_total))) || '--'}
          isLoading={isLoading}
          testId="banking_deposit_fee_total"
        />

        <ResumeBox
          padding="small"
          boxClassName="flex-1 text-danger-soft"
          label="Valor total"
          value={(bankingDeposit?.created_at && formatCurrency(Number(bankingDeposit.total_value))) || '--'}
          isLoading={isLoading}
          testId="banking_deposit_total_value"
        />
      </div>
    </div>
  );
}

export default BankingDepositResume;
